export const highlightClasses = [
  '!tw-outline-sf-primary-dark',
  '!tw-outline',
  '!tw-outline-2',
  'tw-z-10',
]
